module.exports = __webpack_public_path__ + "img/ps_platform.c0134e74.svg";